import { createOfferResource } from './offerResourceFactory'

/**
 * Цінові пропозиції запитів (`SPEC-024` §3.3, §8) — блок «Цінові пропозиції»
 * картки власника. Ключ прав беку — `RequestOffer` (`ResourceCorrespondenceConfig`).
 */
export const RequestOfferResource = createOfferResource('request')
